<template>

    <div>

        <div class="form-row">
            <div class="form-group col-12" >
                <label>{{ trad.card_number }}</label>
                <div id="card-element"></div>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-6">
                <label>{{ trad.card_expiration }}</label>
                <div id="expiry-element"></div>
            </div>
            <div class="form-group col-6">
                <label class="d-flex">{{ trad.card_cvc }} <div class="helper center" @click="showCVCHelper = !showCVCHelper">?</div></label>
                <div id="cvc-element"></div>
				<p class="form-text text-muted" v-show="showCVCHelper">{{ trad.card_cvc_helper }}</p>
            </div>
        </div>

        <div class="row justify-content-md-center">
            <div class="col-12">
                <span id="card-errors"></span>
            </div>
        </div>

    </div>

</template>

<script>

	export default {

		props: {
			trad: {
				required: true
			},
			stripeKey: {
				required: true
			}
		},

        data() {
          return {
              stripe: null,
              elements: [],
              errors: [],

              valid: false,
              source: null,
              brand: null,
			  showCVCHelper: false,
          }
        },

        mounted() {
            this.init()
        },

        methods: {

            init() {
                this.stripe = Stripe(this.stripeKey)
                this.mountElements()
            },

            mountElements() {

                let elements = this.stripe.elements({
                    locale: document.documentElement.getAttribute('lang'),
                });

                let card = elements.create('cardNumber')
                card.mount(document.getElementById('card-element'))

                let expiry = elements.create('cardExpiry')
                expiry.mount(document.getElementById('expiry-element'))

                let cvc = elements.create('cardCvc')
                cvc.mount(document.getElementById('cvc-element'))

                this.elements = [card, expiry, cvc]

                this.registerElements()
            },

            registerElements() {
                this.elements.forEach((element, idx) => {
                    element.addEventListener('change', (event) => {
                        this.changeHandler(event, idx)
                    })
                })
            },

            changeHandler(event, idx) {

                let displayError = document.getElementById('card-errors')

                if(event.brand)
                    this.brand = event.brand

                if(event.error) {
                    this.errors[idx] = event.error.message
                    displayError.textContent = event.error.message
                    this.valid = false
                } else {
                    this.errors[idx] = null

                    let nextError = Object.keys(this.errors)
                        .sort()
                        .reduce((maybeFoundError, key) => {
                            return maybeFoundError || this.errors[key]
                        }, null);

                    displayError.textContent = nextError ? nextError : null
                }
            },

            getSource() {
                return this.stripe.createSource(this.elements[0])
                    .then((result) => {

                        let errorElement = document.getElementById('card-errors')

                        if (result.error) {
                            errorElement.textContent = result.error.message
                            throw result.error.message
                        }

						errorElement.textContent = ''
						this.source = result.source

						return this.source

						// 3DS
						// if(result.source.card.three_d_secure === 'required') {
						// // if(result.source.card.three_d_secure !== 'not_supported') {
						// 	// console.log('supported');
						//
						// 	this.create3dSecureSource(result.source)
						//
						// } else {
						//
						// 	errorElement.textContent = ''
	                    //     this.source = result.source
						//
	                    //     return this.source
						// }
						// 3DS

                    })
            },

            create3dSecureSource(source) {
                return this.stripe.createSource({
                    type: 'three_d_secure',
                    amount: 1099,
                    currency: "eur",
                    three_d_secure: {
                        card: source.id
                    },
                    redirect: {
						return_url: "http://restopass.test/fr/subscription/payment/3dsecure"
                        // return_url: "http://dev.restopass.review.1md.be/fr/subscription/payment/3dsecure"
						// return_url: "http://restopass.test/fr/subscription/payment/3dsecure"
                    }
                })
                .then((result) => {

                    if(result.source){
                        window.location = result.source.redirect.url
                        return
                    }

                    return source
                });
            },

            getToken() {
                return this.stripe.createToken(this.elements[0])
                    .then((result) => {

                        let errorElement = document.getElementById('card-errors')

                        if (result.error) {
                            errorElement.textContent = result.error.message
                            throw result.error.message
                        } else {
                            errorElement.textContent = ''
                            this.source = result.token
                            return this.source.id
                        }
                    });
            }

        }

    }

</script>

<style>
    .StripeElement {
        background-color: white;
        width: 100%;
        height: 40px;
        padding: 10px 12px;
        border-radius: 4px;
        border: 1px solid #aaa;
        transition: box-shadow 150ms ease;
    }

    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/RCard.vue